import {
  createErrorType,
  createFetchType,
  createLoadingType,
  createSuccessType,
} from '../actionHelpers';

export const SETTINGS_FETCH = createFetchType('SETTINGS');
export const SETTINGS_SUCCESS = createSuccessType('SETTINGS');
export const SETTINGS_ERROR = createErrorType('SETTINGS');
export const SETTINGS_LOADING = createLoadingType('SETTINGS');
